import React from 'react';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useSelector } from 'react-redux';
import { styled } from '@mui/material/styles';
import useMediaUrl from 'hooks/useMediaURL';
import PlayIcon from '@mui/icons-material/PlayCircleFilledWhiteOutlined';
import WidgetLisItem from 'modules/connect-card-widget/components/WidgetListItem';

const StyledRoot = styled('div')`
  overflow: hidden;
  width: 375px;
  height: 500px;
  position: absolute;
  right: 10px;
  bottom: 10px;
  border-radius: 25px;
  padding-top: 30px;
  background-color: ${({ theme }) => theme.palette.background.default};
  .wrapper {
    overflow: auto;
    height: 100%;
  }
  .card {
    position: relative;
    max-width: 600px;
    padding: 15px;
    .lead {
      font-size: 22px;
      font-weight: 300;
    }
  }
  .logo-box {
    margin: auto;
    max-width: 120px;
    height: 70px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 15px;

    &.placeholder {
      border: 1px dashed #2186eb;
      color: #2186eb;
    }
    img {
      width: 100%;
      max-height: 100%;
      object-fit: contain;
    }
  }
  .MuiButton-containedPrimary {
    border: none;
  }
  .card-item {
    position: relative;
    color: white;
    height: 55px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    margin-bottom: 10px;
    border-radius: 10px;
    font-weight: 500;
    padding: 0 10px 0 15px;
    margin-left: 10px;
    margin-right: 10px;

    &.primary {
      padding: 20px;
      height: auto;
      margin-left: 0;
      margin-right: 0;
      margin-bottom: 15px;
      p:nth-child(2) {
        font-size: 90%;
        opacity: 0.8;
      }
    }
  }
`;

const SAMPLE_CARDS = [
  { id: 1, overlay_text: 'Sample Card 1', overlay_description: '' },
  { id: 2, overlay_text: 'Sample Card 2' },
  { id: 3, overlay_text: 'Sample Card 2' },
];

export default ({ data, cards, color }) => {
  const [t] = useTranslation('groups');
  const account = useSelector((s) => s.settings.account);
  const logoUrl = useMediaUrl(account.account_logo_url);

  const {
    collection_title,
    collection_description,
    logo_or_video_url,
    logo_or_video,
  } = data;

  const cardsToRender = cards.length ? cards : SAMPLE_CARDS;

  return (
    <StyledRoot>
      <div className="wrapper">
        <Box className="card">
          <Box textAlign="center" mb={3}>
            {logo_or_video === 'video' ? (
              <div className="video">
                <PlayIcon />
              </div>
            ) : logo_or_video_url || logoUrl?.url ? (
              <div className="logo-box">
                <img className="logo" src={logo_or_video_url || logoUrl.url} />
              </div>
            ) : (
              <div className="logo-box">{t('cc-logo', 'Your Logo')}</div>
            )}
            <Typography variant="h4" fontWeight={600}>
              {collection_title || 'Headline'}
            </Typography>
            <Typography paragraph>
              {collection_description || 'Description'}
            </Typography>
          </Box>
          <Stack spacing={1} overflow="auto">
            {cardsToRender.map((card, index) => (
              <WidgetLisItem
                isPrimary={index === 0}
                onClick={() => false}
                title={card.overlay_text || card.card?.card_headline}
                subtitle={
                  card.overlay_description || card.card?.card_description
                }
                key={index}
              />
            ))}
          </Stack>
        </Box>
      </div>
    </StyledRoot>
  );
};
